import React from "react"
import configData from '../../config/config.json';
//import Rating from "react-rating" // https://www.npmjs.com/package/react-rating
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDoubleLeft, faMoon, faCalendar, faChevronDown } from "@fortawesome/free-solid-svg-icons";
import Modal from 'react-responsive-modal';
import 'react-responsive-modal/styles.css';
import Cookies from 'universal-cookie';
import CardLineFlights from "./CardLineFlights";
import CardLineHotel from "./CardLineHotel";
import BaggageIcons from '../../features/Baggage';
import moment from "moment";
import { withTranslation } from 'react-i18next';
import i18n from '../../i18n';
//import './CardLine.css';
//import Deal from "./Deal"

// Initialize moment Hebrew locale with translations
const initMomentLocale = () => {
    const months = [
        i18n.t('common.months.january'),
        i18n.t('common.months.february'),
        i18n.t('common.months.march'),
        i18n.t('common.months.april'),
        i18n.t('common.months.may'),
        i18n.t('common.months.june'),
        i18n.t('common.months.july'),
        i18n.t('common.months.august'),
        i18n.t('common.months.september'),
        i18n.t('common.months.october'),
        i18n.t('common.months.november'),
        i18n.t('common.months.december')
    ];

    moment.locale('he', {
        months: months,
        monthsShort: months
    });
};

initMomentLocale(); 

//var lastObj = null;

const API_ENDPOINT = configData.API_ENDPOINT;

class CardLine extends React.Component {

    constructor (props) {
        super(props);

        this.handleClick = this.handleClick.bind(this); 
        this.handleMoreDetailsBtn = this.handleMoreDetailsBtn.bind(this); 
        this.showDealID = this.showDealID.bind(this)
        this.counter = 0;

        
    }

    
    componentDidMount() {
       // initGA();
    }

    isFriend = async(event, url, source, deal_id) => {
        window.location = url
    }

    getStarsImage(num) {
        let output = "";

        for (let i=0;i<num;i++) {
            output+="★";
        }

        return output;
    }

    getDays(day1, day2) {
        const { t } = this.props;
        const dayNames = [
            t('common.days.sundayShort'),
            t('common.days.mondayShort'),
            t('common.days.tuesdayShort'),
            t('common.days.wednesdayShort'),
            t('common.days.thursdayShort'),
            t('common.days.fridayShort'),
            t('common.days.saturdayShort')
        ];

        return `${dayNames[day1]} - ${dayNames[day2]}`;
    }

    /*getStarsImage(num) {
        switch(num*1) {
            case 1: return '&#xf006;';
            case 2: return '&#xf006;&#xf006;';
            case 3: return '&#xf006;&#xf006;&#xf006;';
            case 4: return '&#xf006;&#xf006;&#xf006;&#xf006;';
            case 5: return '&#xf006;&#xf006;&#xf006;&#xf006;&#xf006;';
            default: return '';
        }
    }*/

    getCurrencySymbol(cur) {
        let currency_symbol;

        switch( cur ) {
            case 'USD': currency_symbol = '$';break;
            case 'EUR': currency_symbol = 'EURO';break;
            case 'ILS': currency_symbol = 'NIS';break;
            default: currency_symbol = '$';
        }

        return currency_symbol;
    }

    lameLogin(uid, pw) {
        const { createHash } = require('crypto');
        const hashedPw = createHash('sha256').update(pw).digest('hex');
        /*if (hashedPw=='432164f22b5c124cd4971bee34cbd3e4a1c392ee46f4ed5382359ca55f53ed4a' || hashedPw=='879744f88f74c555a26252f1bba694a6d890d4bd844b9a7f7f85e12b8004dbef') {
            const cookies = new Cookies();
            cookies.set('logged',1)
            window.location= '/deal/' + this.props.data.uid;
        }*/
    }

    GetMealPlanCode(code) {
        let local_meal_plan_code='RO';
        
        switch(code) {
            case 'SA'||'SP'||'SC': local_meal_plan_code='RO';break; // Accommodation only
            case 'HD': local_meal_plan_code='BB';break;             // B&B 
            case 'HM'||'MB'||'MP': local_meal_plan_code='HB';break; // HAlf Board
            case 'PC'||'PV': local_meal_plan_code='FB';break;       // Full board
            case 'TI'||'TP': local_meal_plan_code='AI';break;       // All Inclusive
            default: local_meal_plan_code='RO'
        }

        return local_meal_plan_code;
    }

    /**
     * Calculate the number of days / weeks / months between the departure date & today
     * @param {*} departure_date 
     */
    GetTimeToDeparture(departure_date) {
        try {
            const today = new Date();
            const [datestr, timestr] = (departure_date+'').split("T");
            const [year, month, day] = datestr.split("-");
            const departureDate = new Date(+year, +month - 1, +day);

            const difference = departureDate.getTime() - today.getTime();

            const daysToDeparture = Math.ceil(difference / (1000 * 60 * 60 * 24));
            
            switch (true) {
                case daysToDeparture <= 2: return '1-2 days';break;
                case daysToDeparture <= 4: return '3-4 days';break;
                case daysToDeparture <= 7: return '5-7 days';break;
                case daysToDeparture <= 10: return '8-10 days';break;
                case daysToDeparture <= 13: return '11-13 days';break;
                case daysToDeparture <= 21: return '2 weeks';break;
                case daysToDeparture <= 28: return '3 weeks';break;
                case daysToDeparture <= 35: return '4 weeks';break;
                case daysToDeparture <= 42: return '5 weeks';break;
                case daysToDeparture <= 49: return '6 weeks';break;
                case daysToDeparture <= 56: return '7 weeks';break;
                case daysToDeparture <= 63: return '8 weeks';break;
                case daysToDeparture <= 70: return '9 weeks';break;
                case daysToDeparture <= 100: return '2 months';break;
                case daysToDeparture <= 130: return '3 months';break;
                case daysToDeparture <= 160: return '4 months';break;
                case daysToDeparture <= 190: return '5 months';break;
                case daysToDeparture <= 220: return '6 months';break;
                case daysToDeparture <= 250: return '7 months';break;
                case daysToDeparture <= 280: return '8 months';break;
                case daysToDeparture <= 310: return '9 months';break;
                case daysToDeparture > 310: return '10+ months';break;
                default: return '';
            }
        } catch(e) {
            return 'ERROR'
        }    
    }

    handleClick = (event) => {       
        const clickResult = this.props?.ToggleDealDetails(event);
    }

    showDealID = async(deal_id)  =>{
        await this.clipboardPermissionsCheck().then(allowed => {
            if (allowed){
                if (navigator.clipboard ) {
                    navigator.clipboard
                        .writeText(deal_id)
                    .then(() => {
                    var snd = new Audio("data:audio/wav;base64,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");  
                        snd.play();
                    })
                    .catch(() => {
                    alert("something went wrong");
                    });
                } else {
                    alert('not allowed')
                }
            } else {
                alert('No permissions')
            }
        });        
    }

    clipboardPermissionsCheck = async () => {
    //let read = await navigator.permissions.query({name: 'clipboard-read'})
        let write = await navigator.permissions.query({name: 'clipboard-write'})
        return write.state === 'granted' //&& read.state != 'denied'
    }

    handleMoreDetailsBtn(event, deal, source) {
        event.stopPropagation()
        // this.handleMoreDetailsBtn(e, '/deal/' + this.props.data.uid, 'more-details-flight', this.props.data.uid)}

        let url = '/deal/' + deal.uid;

        let group_id, city_id, meal_plan, from_date, to_date, stars, property_name;
        
        if (this.props?.data) {
            const deal = this.props.data;
        
            meal_plan = deal.property.meal_code;
            from_date = deal.departure && deal.departure.date ? deal.departure.date.split('T')[0]:'';
            to_date = deal.return && deal.return.date ? deal.return.date.split('T')[0]:'';
            stars = deal.property.stars;
            property_name = deal.property.name;
            city_id =  deal.destination.city.id;
            group_id = deal.gid;
        }

        url += `?cid=${city_id}&gid=${group_id}&out=${from_date}&in=${to_date}&a=${this.props.adults?this.props.adults:0}`;
        this.props.teens && this.props.teens>0 ? url += `&t=${this.props.teens}` : url += `&t=0`;
        this.props.children && this.props.children>0 ? url += `&c=${this.props.children}` : url += `&c=0`;
        this.props.infants && this.props.infants>0? url += `&i=${this.props.infants}` : url += `&i=0`;
        url+=`&s=${stars}&mp=${meal_plan}&hn=${property_name}`;

        const deal_id = this.props.uid;
        event.target.style.backgroundColor = '#aaa'
        //const cookies = new Cookies();
        //if (cookies.get('logged')!=1) {
            //Event("DEALS", source + " button clicked", deal_id)
        //} else {
        //
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ ecommerce: null });  
        window.dataLayer.push({
            event: 'OpenDealDetailsPage',
            value: this.props?.data?.price,
            uid: this.props.data.uid,
            currency: this.props.data.currency,
            departure: this.props.data.departure.date,
            destination: this.props.data.destination.city.id,
            stars: this.props.data.property.stars,
            weekend: this.props.data.weekend_il,
            holidays: this.props.data.holidays,
            vacations: this.props.data.vacations,
            nights: this.props.data.nights,
            ecommerce: {
                currencyCode: this.props.data.currency,
                add: {
                    actionField: {
                        list: 'destination-deal-preview'
                    },
                    products: [{
                        id: this.props.data.uid,
                        name: this.props.data?.code,
                        category: this.props?.country_name+'/'+this.props.city_name+ '/' + this.props.month + '/' + this.props.stars,    
                        brand: 'afnu',
                        quantity: 1,
                        price: this.props?.data?.price,
                    }]

                }
            }
        });
       
        window.dataLayer.push({
            event: "view_item",
            ecommerce: {
              currency: this.props?.data?.currency,
              value: this.props?.data?.price,
              items: [
              {
                item_id: this.props.data.uid,
                item_name: this.props.data?.code,
                index: 0,
                //item_brand: this.state?.destination_name_en, //this.props.city_name,
                item_category:  "adults:2,teens:0,children:0,infants:0,rooms:1",
                item_category2: "stars: " + this.props.data.property?.stars+" meals: " + this.GetMealPlanCode(this.props.data.property.meal_code),
                item_category3: "nights: " + this.props.data?.nights,
                item_category4: "departure: " + this.GetTimeToDeparture(this.props.data.departure?.date),
                item_category5: "month: "+ this.props.data.departure?.date.split("-", 2).join("-"), // remove everything after second dash occurance (which converts the date from 2023-07-29T00:00:00.000Z to 2023-07),
                //item_list_id: "related_products",
                //item_list_name: "Related Products",
                item_variant: "standard",
                location_id: this.props.data.destination.city.id,
                price: this.props?.data?.price,
                quantity: 1
              }
              ]
            },
            eventCallback: function() {
                window.location = url;
              }
          });

        setTimeout(function() {window.location = url}, 500); 
        
        //}
    }
    /*
    handleBookingBtn(event) {
        window.open("/deal/" + this.props.data.deal_id);
        window.open(this.props.data.flight_partner_order_url);
        window.open(this.props.data.property_landing_url);
    }
*/
    getTextualDuration(duration) {
        const { t } = this.props;
        const hours = (duration/60/60+"").split('.')[0];
        const minutes = Math.round((duration/60/60)%1*60);
        return `${hours} ${t('common.duration.hoursAnd')}${minutes} ${t('common.duration.minutes')}`;
    }

    
    getFlightTime(ftime) {
        if (!ftime) return;

        return moment.parseZone(ftime).format("HH:mm")

        //const d = new Date(ftime);
        //const t = ftime.split(/[- :]/);
        const t = ftime.split(/[-T:]/);

        // Apply each element to the Date function
        var date_struct = new Date(t[0], t[1]-1, t[2], t[3], t[4], t[5].split('+')[0]);
        var d = new Date(date_struct);
        
        return ("0" + d.getHours()).slice(-2) + ":" +  ("0"+d.getMinutes()).slice(-2)
    }

    render() {
        const item = this.props?.data;
        
      //  if (this.props.data.hotels == null ) return (<div>NO HOTELS {this.state.to_agoda_city_id}</div>)

        //const deal_price = Math.ceil(this.props.data.deal_price);
        //const departure_date = formatDate(this.props.data.flight.outbound.departure_date);
        //const return_date = formatDate(this.props.data.flight.inbound.arrival_date);
        const departure_date = formatDate(this.props.data.flight.outbound.departure_date)//formatDate(this.props.data.departure.date);
        const return_date = formatDate(this.props.data.flight.inbound.departure_date) //formatDate(this.props.data.return.date);
        const timeDiff = Math.abs(new Date(this.props.data.return.date).getTime() - new Date(this.props.data.departure.date).getTime());
        const nights =  Math.ceil(timeDiff / (1000 * 3600 * 24)); 

        const item_uri = "/deal/" + this.props.data.uid;
        const weekendClass = (this.props.data.weekend_il)?'show':'hide';
        //const holidayClass = (this.props.data.holidays.length>0)?'show':'hide';

        //let baggageArray = item?.flight?.baggage;// =  [];
            
        // Get deal's baggage options - >> TODO :  get all options and then filter only the ones related to the given destination airport
        /*
        if (this.props?.baggage) {

            // Check If flight's destination airport has special pricing in baggage table =>  Keep only the relevant baggage options
            if (this.props?.baggage.find(bag=>bag.airline_code.split(',').includes(item.flight.outbound.airline.code) && bag.destination_airport_iata===item?.flight?.outbound?.arrival_iata)) {
                baggageArray = this.props?.baggage.filter(
                    bag=>{
                        if (bag.airline_code.split(',').includes(item.flight.outbound.airline.code) && bag.destination_airport_iata===item.flight.outbound.arrival_iata)  {
                            return item
                        }
                    }
                )
            } else {
                baggageArray = this.props?.baggage.filter(
                    bag=>{
                        if (bag.airline_code.split(',').includes(item.flight.outbound.airline.code) && bag.destination_airport_iata==undefined )  {
                            return item
                        }
                    }
                )
            }                
        }
        */

    
        let duration_departure, duration_return, out_departure_time,out_arrival_time,in_departure_time,in_arrival_time,to_airline, return_airline=null;

        out_arrival_time = this.getFlightTime(this.props.data.flight.outbound.arrival_date);
        out_departure_time = this.getFlightTime(this.props.data.flight.outbound.departure_date);
        duration_departure = this.getTextualDuration(this.props.data.flight.outbound.duration);
        to_airline = this.props.data.flight.outbound.airline.code;
        //let to_airline_icon = this.props.data.flight.outbound.airline.icon;

        in_departure_time = this.getFlightTime(this.props.data.flight.inbound.departure_date);
        in_arrival_time = this.getFlightTime(this.props.data.flight.inbound.arrival_date);
        duration_return = this.getTextualDuration(this.props.data.flight.inbound.duration);
        return_airline = this.props.data.flight.inbound.airline.code;
        //let return_airline_icon = this.props.data.flight.inbound.airline.icon;
        /*const adults = this.props.data.pax?.adults;
        const teens = this.props.data.pax?.teens;
        const children = this.props.data.pax?.children;
        const infants = this.props.data.pax?.infants;*/
        
        const { t } = this.props;
        const passengersCount = this.props?.passengers_count*1;
        const qsAdults = this.props.adults?this.props.adults*1:2;
        const qsTeens = this.props?.teens?this.props?.teens*1:0;
        const qsChildren = this.props?.children?this.props?.children*1:0;
        const qsInfants = this.props?.infants?this.props?.infants*1:0;

        //const query_string_pax_count = qsAdults + qsTeens + qsChildren + qsInfants;
        //const max_count = adults + teens + children + infants;

        const pricePP = Math.ceil(this.props.data.price/this.props.data.passengers_count)

        //let paxCaption = `לאדם בהרכב ${this.props.data.passengers_count} נוסעים`;
        let paxCaption = `
        ${qsAdults==1 ? t('deals.passengers.adults_one', { count: 1 }) : t('deals.passengers.adults_other', { count: qsAdults })}${qsTeens+qsChildren>0?
            '+'+
            (qsTeens+qsChildren>1 ? t('deals.passengers.children_other', { count: qsTeens+qsChildren }) : t('deals.passengers.child'))
            :''
        }`;

        let paxCaption2 = `${qsInfants>0?'+'+(qsInfants>1 ? t('deals.passengers.infants_other', { count: qsInfants }) : t('deals.passengers.infant')):''}`;

        if (qsAdults+qsTeens+qsChildren+qsInfants != passengersCount) {
            paxCaption = t('deals.passengers.totalPassengers', { count: passengersCount })
        }


        /*
        switch(adults) {
            case 1: paxCaption = 'למבוגר';break;
            case 2: paxCaption = 'לאדם בהרכב זוגי';break;
            default: paxCaption = `לאדם בהרכב ${adults} מבוגרים`;break;
        }

        if (children > 0 || infants > 0) {

            paxCaption = 'לאדם בהרכב ';
            if (adults == 1)
                paxCaption += 'מבוגר'
            if (adults == 2)
                paxCaption += 'זוג'

            if (children > 0)
                paxCaption += '+' + children;

            // add infants
            if (infants > 0) {
                if ( infants === 1)
                    paxCaption += '+תינוק';
                else
                    paxCaption += '+' + infants + ' תינוקות';
            }
        
        }*/


        return (
            <div  className={"lineWrapper card-line-container " +  (this.props.counter>this.props.show?' hide ':'')  +  (this.props?.open?'active':'')} id={ this.props.stars + "-line-" + this.props.counter  } xtitle={t('deals.labels.dealDescription', { nights: nights, startDate: formatDate(this.props.data.flight.outbound.departure_date), endDate: formatDate(this.props.data.flight.inbound.arrival_date) })} key={'month'+(this.counter++)} deal={this.props.data.uid} href={item_uri} style={{order: Math.ceil(pricePP/2)}} >
                <div>

                    <div className={"line card-line-padding line-"+ (this.props.counter+1) + " " + (( (this.props.total >= 3 && this.props.counter<2) || (this.props.total<3 && this.props.counter<this.props.total-1) ) && this.props.member==="0" ?'unlocked':'unlocked')}>
                        <span className="overlay lock_trigger"></span>
                        <div className="dates" style={{fontSize:'1em', margin:`0`, lineHeight:0}}>
                            <h4 style={{fontWeight:800, color:'#333',fontSize:'1.1em'}}>{t('deals.labels.flightAndHotel')}</h4>
                            <div className="symbols"  style={{fontSize:'1em', color:'#888'}}>
                                <div style={{fontWeight:'600', color: '#555', fontSize:'.9em'}}>
                                    <FontAwesomeIcon icon={faMoon} className="card-line-icon-margin" style={{display:'inline-block', fontSize:'0.8em'}} />
                                    <span style={{ fontWeight:700}}>{nights} {t('deals.labels.nights')} </span>
                                    <span style={{color:'#777'}}>({this.getDays( this.props.data.departure.dow, this.props.data.return.dow)})</span>
                                </div>
                            </div>
                            <p className="range" style={{color:'#555',fontSize: '.9em', fontWeight:'600'}}>
                                <FontAwesomeIcon icon={faCalendar} style={{display:'inline-block', margin:'0 0.3em', fontSize:'0.9em',}} />
                                {formatDate(this.props.data.flight.inbound.arrival_date)} - {formatDate(this.props.data.flight.outbound.departure_date)}</p>
                        </div>
                        
                        <div className="price" style={{fontSize:'2.23em', color: '#444',display:'flex',flexDirection:'column',justifyContent:'center', padding:0, margin:0}}>
                            <p className="amount" ><span className="from" onClick={(e)=>this.showDealID(this.props.data.uid)}>{t('deals.labels.from')}</span><span className="card-line-price-ltr" style={{unicodeBidi: 'embed'}}>{this.getCurrencySymbol( this.props.data.currency )}{pricePP}</span></p>
                            <p className="amountCaption" style={{fontSize:'0.3em', borderBottom:'none',paddingBottom:0}}>{t('deals.labels.perPersonInGroup')} <br />{paxCaption}<br />{paxCaption2}</p>
                        </div>
                        <div className="more" style={{padding:'0 .25em 0 .25em',display:'flex',flexDirection:'column',justifyContent:'center'}} >
                            <p><FontAwesomeIcon icon={faChevronDown} style={{ margin:'0 0 0 .5em', color: '#555'}}  /> </p>
                        </div>
                    </div>

                </div>
                <div  key={'deal'+(this.counter++)}  className={"dealDetails destinationDealDetails " + (this.props?.open?'active':'')} id={this.props.data.flight_uid} >
                    <div className="card-line-details-reverse" style={{display:'flex', margin:'0 .25em', justifyContent:'space-between', border:'1px solid #bbb'}} onClick={(e)=>this.handleMoreDetailsBtn(e, this.props.data, 'more-details-flight')}>
                        <div className="title sideTab"  style={{background:'#1e5881', padding:0}}>{t('deals.labels.flight')}</div>
                        <CardLineFlights key={'cardflight'+(this.counter++)} data={this.props.data}></CardLineFlights>
                    </div>

                    <div className="card-line-details-reverse" style={{display:'flex', margin:'0 .25em .25em', justifyContent:'space-between', borderBottom:'1px solid #bbb', borderLeft:'1px solid #bbb', borderRight:'1px solid #bbb'}} onClick={(e)=>this.handleMoreDetailsBtn(e, this.props.data, 'more-details-hotel')}>
                        <div className="title sideTab" style={{background:'#02badb', padding:0}}>{t('deals.labels.hotel')}</div>
                        <CardLineHotel key={'cardhotel'+(this.counter++)} data={this.props.data} photo={this.props?.property_photo}></CardLineHotel>
                    </div>          

                    {to_airline == return_airline ? <BaggageIcons baggage={this.props?.data?.flight?.baggage} ></BaggageIcons> : null}
                    
                    {/*<hr style={{margin:'0 1em'}} />*/}
                    <div style={{padding:'0.75em .5em 1em'}}>
                        <div style={{fontSize:'0.8em'}}>
                            <button style={{display:'flex', justifyContent:'center', alignItems:'center',width: '100%', padding:'0.8em 0.2em', borderRadius:'5px', backgroundColor: '#fed102', fontSize:'1.2em', border:'none', fontWeight:'700',color:'#000'}} onClick={(e)=>this.handleMoreDetailsBtn(e, this.props.data, 'more-details')} title={t('deals.labels.moreDetails')}>{t('deals.labels.moreDetails')}
                                <FontAwesomeIcon icon={faAngleDoubleLeft} style={{ margin:'0 .5em 0 .5em'}} />
                            </button>
                        </div>
                    </div>

              
                </div>
                

            </div>

        )
    }


    
}

function formatDate(date) {
    return moment.parseZone(date).format("DD/MM/YYYY");
    // Remove timezone data
    if (date.indexOf('+') > 0)
        date = date.slice(0,date.indexOf('+'))

    const d = new Date(date);


    return ("0" + d.getDate()).slice(-2) + "/" + ("0"+(d.getMonth()+1)).slice(-2) + "/" +
    d.getFullYear();
}


export default withTranslation()(CardLine)